import { create } from 'zustand';

/** The three views of the same place: production's Map · BIM · Globe switch. */
export type ViewMode = 'map' | 'globe' | 'bim';

/**
 * The camera a view hands to the next when the mode changes, so switching keeps the place in view. Map and
 * Globe speak it natively; BIM converts it to its own camera distance and back.
 */
export interface SharedCamera {
  /** [lon, lat] in degrees (EPSG:4326). */
  center: readonly [number, number];
  /** Web Mercator zoom equivalent (the 2D map's zoom at this latitude). */
  zoom: number;
  /** Degrees clockwise from north. */
  bearing: number;
  /** Degrees from looking straight down (0 = top-down). The 2D map has none, so it lands flat there. */
  pitch: number;
}

interface ViewModeState {
  mode: ViewMode;
  /** Written by the view being left, read by the view being entered. */
  camera: SharedCamera | null;
  setMode: (mode: ViewMode) => void;
  handOver: (camera: SharedCamera) => void;
}

export const useViewMode = create<ViewModeState>()((set) => ({
  mode: 'map',
  camera: null,
  setMode: (mode) => set({ mode }),
  handOver: (camera) => set({ camera }),
}));
